// src/hooks/useAuthGate.ts
import { useUser } from 'util/UserContext';

export function useAuthGate() {
  const { currentUser, setShowAuthModal } = useUser();
  const requireAuth = () => {
    if (!currentUser) {
      setShowAuthModal(true);
      return false;
    }
    return true;
  };
  return { currentUser, requireAuth };
}
